export var Easing;
(function (Easing) {
    Easing["easeInSine"] = "easeInSine";
    Easing["easeOutSine"] = "easeOutSine";
    Easing["easeInOutSine"] = "easeInOutSine";
    Easing["easeInQuad"] = "easeInQuad";
    Easing["easeOutQuad"] = "easeOutQuad";
    Easing["easeInOutQuad"] = "easeInOutQuad";
    Easing["easeInCubic"] = "easeInCubic";
    Easing["easeOutCubic"] = "easeOutCubic";
    Easing["easeInOutCubic"] = "easeInOutCubic";
    Easing["easeInQuart"] = "easeInQuart";
    Easing["easeOutQuart"] = "easeOutQuart";
    Easing["easeInOutQuart"] = "easeInOutQuart";
    Easing["easeInQuint"] = "easeInQuint";
    Easing["easeOutQuint"] = "easeOutQuint";
    Easing["easeInOutQuint"] = "easeInOutQuint";
    Easing["easeInExpo"] = "easeInExpo";
    Easing["easeOutExpo"] = "easeOutExpo";
    Easing["easeInOutExpo"] = "easeInOutExpo";
    Easing["easeInCirc"] = "easeInCirc";
    Easing["easeOutCirc"] = "easeOutCirc";
    Easing["easeInOutCirc"] = "easeInOutCirc";
    Easing["easeInBack"] = "easeInBack";
    Easing["easeOutBack"] = "easeOutBack";
    Easing["easeInOutBack"] = "easeInOutBack";
    Easing["easeInElastic"] = "easeInElastic";
    Easing["easeOutElastic"] = "easeOutElastic";
    Easing["easeInOutElastic"] = "easeInOutElastic";
    Easing["easeInBounce"] = "easeInBounce";
    Easing["easeOutBounce"] = "easeOutBounce";
    Easing["easeInOutBounce"] = "easeInOutBounce";
})(Easing || (Easing = {}));
